import { useMemo } from 'react';

const useFeatureFlags = () => {
  const featureFlags = useMemo(() => {
    // Debug: Log environment variables
    // console.log('🔧 Feature Flags Debug:');
    // console.log('REACT_APP_ENABLE_QUICK_ACTIONS:', process.env.REACT_APP_ENABLE_QUICK_ACTIONS);
    // console.log('REACT_APP_SHOW_PEOPLE_ALSO_SEARCHED:', process.env.REACT_APP_SHOW_PEOPLE_ALSO_SEARCHED);
    // console.log('REACT_APP_ENABLE_BIBLICAL_EXPLORATION_PROGRESS:', process.env.REACT_APP_ENABLE_BIBLICAL_EXPLORATION_PROGRESS);

    const flags = {
      // Video Recording Feature
      videoRecording: process.env.REACT_APP_ENABLE_VIDEO_RECORDING === 'true',

      // Screen Capture Feature
      screenCapture: process.env.REACT_APP_ENABLE_SCREEN_CAPTURE !== 'false',

      // People Also Searched Feature
      peopleAlsoSearched: process.env.REACT_APP_SHOW_PEOPLE_ALSO_SEARCHED === 'true',

      // System Style Configuration
      systemStyle: parseInt(process.env.REACT_APP_SYSTEM_STYLE || '2', 10),

      // Quick Actions Feature (Action buttons below responses)
      quickActions: process.env.REACT_APP_ENABLE_QUICK_ACTIONS === 'true',

      // Biblical Exploration Progress Feature
      biblicalExplorationProgress: process.env.REACT_APP_ENABLE_BIBLICAL_EXPLORATION_PROGRESS === 'true',

      // Edge Type Selector Feature
      edgeTypeSelector: process.env.REACT_APP_ENABLE_EDGE_TYPE_SELECTOR === 'true',
    };

    // console.log('🚀 Computed Feature Flags:', flags);
    return flags;
  }, []);

  return featureFlags;
};

export default useFeatureFlags;